import {useState} from 'react';

const InstructionsLogin = ({ language }) => {
  const [isShown, setIsShown] = useState(false);

  const handleClick = () => {
    // toggle between states
    setIsShown(!isShown);
  }

  if (language === 'en') {
    return (
        <div className='instructions-container'>
            <button className='btn-instructions'
                onClick={()=> handleClick()}>
                INSTRUCTIONS
            </button>
    
          {/* show elements on click */}
          {isShown && (
            <div>
                <h2 className='instructions-login'>
                    To open a questionnaire, you need to set up your account. We need it only to protect 
                    your data and not to collect any personal information. Please select your preferred 
                    language for questionnaire by clicking on language symbols at the top of the app. 
                    Please enter any username which must be unique. Any combination of letters and numbers 
                    is fine. Then enter password of your choice. After clicking “Sign up” button your account 
                    will be set and the questionnaire will be opened. Please answer the questions and when 
                    you done do not forget to click on the button “READY” which will become available at the 
                    end of the questionnaire (scroll down) after you answered questions. Now your information 
                    will be in database and you can review it later on when you “Sign in” with your username 
                    and password. You also will get access to your personal QR-code which you can use to 
                    contact GlucoNutris to get free access to pilot version of our app which will be released 
                    during summer 2023.
                </h2>
            </div>
          )}
    
        </div>
      )
  } else if (language === 'sw') {
    return (
        <div className='instructions-container'>
            <button className='btn-instructions' 
                onClick={()=> handleClick()}>
                INSTRUKTIONER
            </button>
    
          {/* show elements on click */}
          {isShown && (
            <div>
                <h2 className='instructions-login'>
                    För att öppna ett frågeformulär måste du skapa ditt konto. Vi behöver det 
                    bara för att skydda dina uppgifter och inte för att samla in din personlig 
                    information. Välj önskad språk för frågeformuläret genom att klicka på 
                    språksymboler högst upp i appen. Sen ange ett användarnamn som måste vara 
                    unikt. Vilken som helst kombination av bokstäver och siffror är bra. 
                    Ange sedan valfritt lösenord. Sedan klicka på "Sign up" -knappen och ditt konto 
                    kommer att skapas och frågeformuläret öppnar sig. Svara gärna på frågorna och 
                    när du gjort glöm inte att klicka på knappen "READY” som blir tillgänglig på 
                    slutet av frågeformuläret (rulla nedåt) efter att du har svarat på frågor. 
                    Nu kommer din information finnas i databasen och du kan granska den senare när 
                    du "Sign in" med ditt användarnamn och lösenord. Du får också tillgång till 
                    din personliga QR-kod som du kan använda för att kontakta GlucoNutris för att 
                    få fri tillgång till pilotversion av vår app som skall vara färdig under sommaren 2023.
                </h2>
            </div>
          )}
    
        </div>
      )
  } else if (language === 'es') {
    return (
        <div className='instructions-container'>
            <button className='btn-instructions'
                onClick={()=> handleClick()}>
                INSTRUCCIONES
            </button>
    
          {/* show elements on click */}
          {isShown && (
            <div>
                <h2 className='instructions-login'>
                    Para abrir un cuestionario, debe configurar su cuenta. Solo lo necesitamos para 
                    proteger sus datos y no para recopilar ninguna información personal. Seleccione 
                    su idioma preferido para el cuestionario haciendo clic en los símbolos de idioma 
                    en la parte superior de la aplicación. Introduzca cualquier nombre de usuario que 
                    debe ser único. Cualquier combinación de letras y números está bien. Luego ingrese 
                    la contraseña de su elección. Después de hacer clic en el botón "Sign up", se 
                    establecerá su cuenta y se abrirá el cuestionario. Por favor, responda las preguntas 
                    y cuando haya terminado, no olvide hacer clic en el botón "READY" que estará disponible 
                    al final del cuestionario (desplácese hacia abajo) después de responder a las 
                    preguntas. Ahora su información estará en la base de datos y podrá revisarla más 
                    adelante cuando "Sign in" con su nombre de usuario y contraseña. También tendrá acceso 
                    a su código QR personal que puede usar para ponerse en contacto con GlucoNutris para 
                    obtener acceso gratuito a la versión piloto de nuestra aplicación que se lanzará durante 
                    el verano de 2023.
                </h2>
            </div>
          )}
    
        </div>
      )
  }


}
export default InstructionsLogin

// function Box() {
//   return (
//     <div>
//       <h2>Box</h2>
//     </div>
//   );
// }
